const PieChartSkeleton = () => {
  return (
    <div className="p-4 min-w-[200px] h-[100px] max-w-[200px] bg-primary-skeleton rounded-lg flex justify-center items-center animate-pulse">
      <div className="flex-1">
        <div className="w-[250px] h-[250px] bg-secondary-skeleton rounded-full"></div>
      </div>
      <div className="flex-2 flex flex-col gap-1 ml-5">
        <div className="w-[40%] h-3 bg-primary-background rounded mb-2"></div>
        <div className="w-[40%] h-3 bg-primary-background rounded mb-2"></div>
        <div className="w-[40%] h-3 bg-primary-background rounded mb-2"></div>
        <div className="w-[40%] h-3 bg-primary-background rounded mb-2"></div>
        <div className="w-[40%] h-3 bg-primary-background rounded"></div>
      </div>
    </div>
  )
}

export default PieChartSkeleton
